// extracted by mini-css-extract-plugin
export default {"alertsContainer":"AlertSectionLayout_alertsContainer__0lFTO","fullView":"AlertSectionLayout_fullView__i1hyb","shimmer":"AlertSectionLayout_shimmer__S39QD"};